import React from 'react'
import Container from '../../Container/Container'

import { Pagination ,Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";


// images
import casei from '../../../assets/images/product/typeProduct/case.png'
import cpu from '../../../assets/images/product/typeProduct/cpu.png'
import fan from '../../../assets/images/product/typeProduct/fan.png'
import graphicCard from '../../../assets/images/product/typeProduct/graphiccard.png'
import hard from '../../../assets/images/product/typeProduct/hard.png'
import hardWD from '../../../assets/images/product/typeProduct/hardwd.png'
import keyboard from '../../../assets/images/product/typeProduct/keyboard.png'
import laptop from '../../../assets/images/product/typeProduct/laptop.png'
import monitor from '../../../assets/images/product/typeProduct/monitor.png'
import motherBoard from '../../../assets/images/product/typeProduct/motherboard.png'
import mouse from '../../../assets/images/product/typeProduct/mouse.png'
import powerSupply from '../../../assets/images/product/typeProduct/powersupply.png'
import ram from '../../../assets/images/product/typeProduct/ram.png'
import ssd from '../../../assets/images/product/typeProduct/ssd.png'

function ProductTypes() {
    return (
        <>
            <Container class1=''>
                        <Swiper
                            slidesPerView={1}
                            spaceBetween={10}
                            breakpoints={{
                                300: {
                                    slidesPerView: 2,
                                    spaceBetween: 20,
                                },
                                640: {
                                    slidesPerView: 3,
                                    spaceBetween: 20,
                                },
                                768: {
                                    slidesPerView: 4,
                                    spaceBetween: 40,
                                },
                                1024: {
                                    slidesPerView: 8,
                                    spaceBetween: 50,
                                },
                            }}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                              }}
                            modules={[Pagination,Autoplay]}
                            className="mySwiper"
                        >
                            <SwiperSlide className='d-flex justify-content-center'>
                                <figure>
                                    <img className='img-fluid ' src={casei} alt="case" />
                                    <figcaption className='text-center'>  کیس </figcaption>
                                </figure>
                            </SwiperSlide>
                            <SwiperSlide>
                                <figure>
                                    <img className='img-fluid ' src={cpu} alt="cpuIntel-i9" />
                                    <figcaption className='text-center'>  سی پی یو </figcaption>
                                </figure>
                            </SwiperSlide>
                            <SwiperSlide>
                                <figure>
                                    <img className='img-fluid ' src={fan} alt="fan" />
                                    <figcaption className='text-center'>  فن </figcaption>
                                </figure>
                            </SwiperSlide>
                            <SwiperSlide>
                                <figure>
                                    <img className='img-fluid ' src={graphicCard} alt="graphicCard" />
                                    <figcaption className='text-center'>  کارت گرافیک </figcaption>
                                </figure>
                            </SwiperSlide>
                            <SwiperSlide>
                                <figure>
                                    <img className='img-fluid ' src={hardWD} alt="hardWD" />
                                    <figcaption className='text-center'>  هارد </figcaption>
                                </figure>
                            </SwiperSlide>
                            <SwiperSlide>
                                <figure>
                                    <img className='img-fluid ' src={keyboard} alt="keyboard" />
                                    <figcaption className='text-center'>  کیبورد </figcaption>
                                </figure>
                            </SwiperSlide>
                            <SwiperSlide>
                                <figure>
                                    <img className='img-fluid ' src={laptop} alt="laptop" />
                                    <figcaption className='text-center'>  لپتاپ </figcaption>
                                </figure>
                            </SwiperSlide>
                            <SwiperSlide>
                                <figure>
                                    <img className='img-fluid ' src={monitor} alt="monitor" />
                                    <figcaption className='text-center'>  مانیتور </figcaption>
                                </figure>
                            </SwiperSlide>
                            <SwiperSlide>
                                <figure>
                                    <img className='img-fluid ' src={motherBoard} alt="motherBoard" />
                                    <figcaption className='text-center'>  مادربرد </figcaption>
                                </figure>
                            </SwiperSlide>
                            <SwiperSlide>
                                <figure>
                                    <img className='img-fluid ' src={mouse} alt="mouse" />
                                    <figcaption className='text-center'>  موس </figcaption>
                                </figure>
                            </SwiperSlide>
                            <SwiperSlide>
                                <figure>
                                    <img className='img-fluid ' src={powerSupply} alt="powerSupply" />
                                    <figcaption className='text-center'>  پاور </figcaption>
                                </figure>
                            </SwiperSlide>
                            <SwiperSlide>
                                <figure>
                                    <img className='img-fluid ' src={hard} alt="hard" />
                                    <figcaption className='text-center'>  هارد </figcaption>
                                </figure>
                            </SwiperSlide>
                            <SwiperSlide>
                                <figure>
                                    <img className='img-fluid ' src={ram} alt="ram" />
                                    <figcaption className='text-center'>  رم </figcaption>
                                </figure>
                            </SwiperSlide>
                            <SwiperSlide>
                                <figure>
                                    <img className='img-fluid ' src={ssd} alt="ssd" />
                                    <figcaption className='text-center'>  اس اس دی </figcaption>
                                </figure>
                            </SwiperSlide>
                        </Swiper>
            </Container>
        </>
    )
}

export default ProductTypes